import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const ApprovalButton = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.CONFIRM);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    const response = await saveDocument();
    if (response === null) {
      return;
    }

    const confirmationAction =
      records.length === 1
        ? actions.modal.openModal(modalActionType.documents.CONFIRM)
        : actions.modal.openModal(modalActionType.documents.MULTIPLE_CONFIRM);
    dispatch(confirmationAction);
  };

  return (
    <CommonButton
      id={actionType.CONFIRM}
      value={t(actionType.CONFIRM)}
      customIcon="fa-check"
      scope="tertiary"
      action={onClick}
      disabled={!utils.user.isActionEnabled(records, actionType.CONFIRM)}
    />
  );
};

export default ApprovalButton;
